import { render, staticRenderFns } from "./chat-input.vue?vue&type=template&id=4ebb1a6e&"
import script from "./chat-input.vue?vue&type=script&lang=js&"
export * from "./chat-input.vue?vue&type=script&lang=js&"
import style0 from "./chat-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports